import { Button, Card, Col, Empty, Row, Spin } from "antd";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ASIDeviceService } from "../../ducks/asi-devices/asi-devices";
import { useI18n } from "../../i18n/I18nContext";

interface AsiCard {
  _id: string;
  description: string;
  comment?: string;
  deviceId?: string;
}

const DevicesAsiByHubPage = () => {
  const { t } = useI18n();
  const navigate = useNavigate();
  const { hubExternalId } = useParams();
  const [list, setList] = useState<AsiCard[]>([]);
  const [loading, setLoading] = useState(false);
  const service = new ASIDeviceService();

  const hubId = hubExternalId ? decodeURIComponent(hubExternalId) : "";

  useEffect(() => {
    const load = async () => {
      if (!hubId) return;
      setLoading(true);
      try {
        const data = await service.getPublicList(hubId);
        setList(data || []);
      } catch (e) {
        console.log(e);
        setList([]);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [hubId]);

  if (loading) {
    return <Spin />;
  }

  return (
    <div>
      <Button
        type="link"
        onClick={() => navigate("/devices")}
        style={{ paddingLeft: 0, marginBottom: 8 }}
      >
        ← {t("asi.back")}
      </Button>
      <h2 style={{ marginBottom: 16 }}>{t("asi.title")}</h2>
      {!list.length ? (
        <Empty description={t("asi.empty")} />
      ) : (
        <Row gutter={[16, 16]}>
          {list.map((asi) => (
            <Col xs={24} sm={12} md={8} key={asi._id}>
              <Card
                hoverable
                title={asi.description || asi.deviceId || asi._id}
                onClick={() => navigate(`/devices/${asi._id}`)}
              >
                <div>
                  <strong>{t("asi.comment")}:</strong> {asi.comment || "—"}
                </div>
              </Card>
            </Col>
          ))}
        </Row>
      )}
    </div>
  );
};

export default DevicesAsiByHubPage;
